
export interface GeneralProposalIsEntity {

    id?: number | null,
	proposalId?: number | null,
	proposalItemId?: number | null,
	shiftCode?: string | null,
	percentage?: number | null,
	
	tempKey?: string | null,

    [key: string]: string | boolean | number | Date | null | undefined | Object
}

export const EMPTY_GEN_PROPOSAL_IS_ENTITY: GeneralProposalIsEntity = {

    id: null,
	proposalId: null,
	proposalItemId: null,
	shiftCode: null,
	percentage: null,
}